import { AllEntityId } from '../config/allEntityId';
import { ENTITY } from '../config/routes/entity';
import { useFetchedCampaign } from './useFetchedCampaign';
import { useReportEntityIds } from './useReportEntityIds';
import { useReportEntityType } from './useReportEntityType';

export const useSelectedCampaign = () => {
    const [selectedEntityIds] = useReportEntityIds();
    const [selectedEntityType] = useReportEntityType();
    const campaignId = selectedEntityType === ENTITY.CAMPAIGN ? selectedEntityIds : AllEntityId;
    const { campaign, isError, isSuccess } = useFetchedCampaign(campaignId);

    return { campaign, campaignId, isError, isSuccess };
};
